import type { PlaidAccount } from "react-plaid-link";

import { Button } from "@alpacahq/ui/old";

import { PlaidIcon } from "~/v2/components/common/PlaidIcon";

interface PlaidCardProps {
  plaidAccount: PlaidAccount | undefined;
  onLinkBankAccount: () => void;
  isLinkButtonDisabled: boolean;
  isLinkButtonLoading: boolean;
}

export const PlaidCard = ({
  plaidAccount,
  onLinkBankAccount,
  isLinkButtonDisabled,
  isLinkButtonLoading,
}: PlaidCardProps) => (
  <section className="flex flex-col gap-3 rounded-lg border border-gray-300 bg-white p-3">
    <div className="flex items-center justify-between gap-4">
      <h3 className="m-0 p-0 text-left font-semibold text-base text-gray-800">
        Link your bank account
      </h3>
      <PlaidIcon />
    </div>
    {plaidAccount ? (
      <>
        <p className="m-0 p-0 text-gray-600 text-sm">
          Your linked bank account will be charged:
        </p>
        <p className="m-0 inline-flex items-center justify-start gap-1 p-0 text-gray-700 text-sm">
          <span className="font-semibold">{plaidAccount.name}</span> ending in{" "}
          <span className="inline-flex items-center justify-center rounded-full border border-gray-300 bg-gray-50 px-2 py-1 font-mono text-xs">
            {plaidAccount.mask}
          </span>
        </p>
      </>
    ) : (
      <>
        <p className="m-0 p-0 text-gray-600 text-sm">
          Log in to your bank and authorize the link to fund your Algo Trader
          Plus subscription now. Alpaca never receives your bank credentials.
        </p>
        <Button
          className="w-fit"
          variant="v2/filled"
          onClick={onLinkBankAccount}
          disabled={isLinkButtonDisabled}
          loading={isLinkButtonLoading}
        >
          Link Bank Account
        </Button>
      </>
    )}
  </section>
);
